import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-organization-share-sms',
  templateUrl: './share-sms.component.html',
  styleUrls: [
    '../../property-share-modal/share-emails/share-emails.component.scss',
    './share-sms.component.scss',
  ],
})
export class OrganizationShareSmsComponent {
  @Output() handleClose = new EventEmitter<void>();
}
